import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzRt } from './pages'

type TIdToPageMapWoofzRt = Record<PageIdWoofzRt, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_RT: TIdToPageMapWoofzRt = {
  [PageIdWoofzRt.SEX_RT_2_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogSexQuestionRtv2').then(
        (m) => ({
          default: m.DogSexQuestionRtv2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogSexQuestionRtv2'),
  },
  [PageIdWoofzRt.DOG_AGE_RT_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogAgeQuestionRtv2').then(
        (m) => ({
          default: m.DogAgeQuestionRtv2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogAgeQuestionRtv2'),
  },
  [PageIdWoofzRt.URGE_RT_V1_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRtv2').then((m) => ({
        default: m.UrgePageRtv2,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRtv2'),
  },
  [PageIdWoofzRt.CHALLENGES_RT_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/ChallengeQuestionRtv2'
      ).then((m) => ({
        default: m.ChallengeQuestionRtv2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/ChallengeQuestionRtv2'),
  },
  [PageIdWoofzRt.WALKS_FEEL_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/questions/WalksFeelRtv2').then(
        (m) => ({
          default: m.WalksFeelRtv2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/WalksFeelRtv2'),
  },
  [PageIdWoofzRt.DOG_EXCITEMENTS_TRIGGERS_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/DogExcitementTriggersRtv2'
      ).then((m) => ({
        default: m.DogExcitementTriggersRtv2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/DogExcitementTriggersRtv2'
      ),
  },
  [PageIdWoofzRt.URGE_RT_5_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT5Rtv2').then((m) => ({
        default: m.UrgePageRT5Rtv2,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT5Rtv2'),
  },
  [PageIdWoofzRt.DOG_MISBEHAVES_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/DogMisbehavesQuestionRtv2'
      ).then((m) => ({
        default: m.DogMisbehavesQuestionRtv2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/DogMisbehavesQuestionRtv2'
      ),
  },
  [PageIdWoofzRt.DOG_ACT_RT_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogActQuestionRtv2').then(
        (m) => ({
          default: m.DogActQuestionRtv2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogActQuestionRtv2'),
  },
  [PageIdWoofzRt.DOG_OFF_AT_HOME_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/DogOffAtHomeQuestionRtv2'
      ).then((m) => ({
        default: m.DogOffAtHomeQuestionRtv2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogOffAtHomeQuestionRtv2'),
  },
  [PageIdWoofzRt.URGE_RT_6_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT6Rtv2').then((m) => ({
        default: m.UrgePageRT6Rtv2,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT6Rtv2'),
  },
  [PageIdWoofzRt.ACCESS_TO_FOOD_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogAccessToFoodRtv2').then(
        (m) => ({
          default: m.DogAccessToFoodRtv2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogAccessToFoodRtv2'),
  },
  [PageIdWoofzRt.URGE_RT_7_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT7Rtv2').then((m) => ({
        default: m.UrgePageRT7Rtv2,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT7Rtv2'),
  },
  [PageIdWoofzRt.DOG_AGGRESSIVE_RT_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/DogRiskyOrAgressiveRtv2'
      ).then((m) => ({
        default: m.DogRiskyOrAgressiveRtv2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogRiskyOrAgressiveRtv2'),
  },
  [PageIdWoofzRt.DOG_CALM_DOWN_RT_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogCalmDownRtv2').then(
        (m) => ({
          default: m.DogCalmDownRtv2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/DogCalmDownRtv2'),
  },
  [PageIdWoofzRt.URGE_RT_8_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT8Rtv2').then((m) => ({
        default: m.UrgePageRT8Rtv2,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT8Rtv2'),
  },
  [PageIdWoofzRt.DOG_BREED_RT_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/dog-breed/DogBreedRtv2'
      ).then((m) => ({
        default: m.DogBreedRtv2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/dog-breed/DogBreedRtv2'),
  },
  [PageIdWoofzRt.URGE_RT_9_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT9Rtv2').then((m) => ({
        default: m.UrgePageRT9Rtv2,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT9Rtv2'),
  },
  [PageIdWoofzRt.COMMANDS_61_RT_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/CommandsQuestionVariant61Rtv2'
      ).then((m) => ({
        default: m.CommandsQuestionVariant61Rtv2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/CommandsQuestionVariant61Rtv2'
      ),
  },
  [PageIdWoofzRt.COMMANDS_62_RT_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/CommandsQuestionVariant62Rtv2'
      ).then((m) => ({
        default: m.CommandsQuestionVariant62Rtv2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/CommandsQuestionVariant62Rtv2'
      ),
  },
  [PageIdWoofzRt.COMMANDS_63_RT_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/CommandsQuestionVariant63Rtv2'
      ).then((m) => ({
        default: m.CommandsQuestionVariant63Rtv2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/CommandsQuestionVariant63Rtv2'
      ),
  },
  [PageIdWoofzRt.URGE_RT_10_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT10Rtv2').then(
        (m) => ({
          default: m.UrgePageRT10Rtv2,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT10Rtv2'),
  },
  [PageIdWoofzRt.URGE_LOADER_RT_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/urge/UrgePageLoaderRtv2').then(
        (m) => ({
          default: m.UrgePageLoaderRtv2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/urge/UrgePageLoaderRtv2'),
  },
  [PageIdWoofzRt.DOG_STATISTICS_RT_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/statistics/DogStatisticsRtv2').then(
        (m) => ({
          default: m.DogStatisticsRtv2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/statistics/DogStatisticsRtv2'),
  },
  [PageIdWoofzRt.TRAINING_RT_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/questions/TrainingQuestionRtv2'
      ).then((m) => ({
        default: m.TrainingQuestionRtv2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/questions/TrainingQuestionRtv2'),
  },
  [PageIdWoofzRt.PREPARE_FLOW_RT_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/prepare-flow/PrepareFlowRtv2').then(
        (m) => ({
          default: m.PrepareFlowRtv2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/prepare-flow/PrepareFlowRtv2'),
  },
  [PageIdWoofzRt.EMAIL_RT_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/email/EmailPage').then((m) => ({
        default: m.EmailPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/email/EmailPage'),
  },
  [PageIdWoofzRt.NEWSLETTER_URGE_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/email/NewsletterUrgeRtv2').then(
        (m) => ({
          default: m.NewsletterUrgeRtv2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/email/NewsletterUrgeRtv2'),
  },
  [PageIdWoofzRt.URGE_RT_4_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT4Rtv2').then((m) => ({
        default: m.UrgePageRT4Rtv2,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/urge/UrgePageRT4Rtv2'),
  },
  [PageIdWoofzRt.LAST_CHANCE_OFFER_RT_V2_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/last-chance-offer/LastChanceOfferRTVariant2Rtv2'
      ).then((m) => ({
        default: m.LastChanceOfferRTVariant2Rtv2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rt/pages/last-chance-offer/LastChanceOfferRTVariant2Rtv2'
      ),
  },
  [PageIdWoofzRt.SUBSCRIPTIONS_RT_RTV2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_rt/pages/subscriptions/SubscriptionsVariantRtv2'
      ).then((m) => ({
        default: m.SubscriptionsVariantRtv2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_rt/pages/subscriptions/SubscriptionsVariantRtv2'
      ),
  },
  [PageIdWoofzRt.CHAT_UPSELL_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzRt.UPSELL_1_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/upsell/Upsell'),
  },
  [PageIdWoofzRt.UPSELL_PITPAT_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/upsell/PitPatUpsell').then((m) => ({
        default: m.PitPatUpsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_rt/pages/upsell/PitPatUpsell'),
  },
  [PageIdWoofzRt.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdWoofzRt.DOWNLOAD_RTV2]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_rt/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_rt/pages/download-app/DownloadApp'),
  },
}
